import { api } from "../../api";

export const configApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getConfig: builder.query({
      query: ({ parentCompany }) => ({
        url: `/config/${parentCompany}?type=parent`,
      }),
      providesTags: (_result, _error, data) => {
        return [{ type: "Config", id: data.parentCompany }];
      },
    }),
    getCustomerConfigRaw: builder.query({
      query: ({ parentCompany }) => ({
        url: `/config/${parentCompany}/customer-config`,
      }),
      providesTags: (_result, _error, data) => {
        return [{ type: "Config", id: data.parentCompany }];
      },
    }),
    fetchConfig: builder.mutation({
      query: ({ parentCompany }) => ({
        url: `/config/${parentCompany}?type=parent`,
        method: "get",
      }),
      providesTags: (_result, _error, data) => {
        return [{ type: "Config", id: data.parentCompany }];
      },
    }),
    createConfig: builder.mutation({
      query: ({ parentCompany }) => ({
        url: `/config/${parentCompany}?type=parent`,
        method: "post",
        body: JSON.stringify({}),
      }),
      invalidatesTags: (_result, _error, data) => {
        return [{ type: "Config", id: data.parentCompany }];
      },
    }),
    updateConfig: builder.mutation({
      query: ({ parentCompany, data }) => ({
        url: `/config/${parentCompany}?type=parent`,
        method: "put",
        body: data,
      }),
      invalidatesTags: (_result, _error, data) => {
        return [{ type: "Config", id: data.parentCompany }];
      },
    }),
    updateCustomerConfigRaw: builder.mutation({
      query: ({ parentCompany, customerConfig }) => ({
        url: `/config/${parentCompany}/customer-config`,
        method: "put",
        body: { customerConfig },
      }),
      invalidatesTags: (_result, _error, data) => {
        return [{ type: "Config", id: data.parentCompany }];
      },
    }),
    deleteConfig: builder.mutation({
      query: ({ parentCompany, data }) => ({
        url: `/config/${parentCompany}?type=parent`,
        method: "delete",
        body: data,
      }),
      invalidatesTags: (_result, _error, data) => {
        return [{ type: "Config", id: data.parentCompany }];
      },
    }),
  }),
});

export const {
  useGetConfigQuery,
  useGetCustomerConfigRawQuery,
  useCreateConfigMutation,
  useFetchConfigMutation,
  useUpdateConfigMutation,
  useUpdateCustomerConfigRawMutation,
  useDeleteConfigMutation,
} = configApi;
